import React from 'react';

interface GradientHeartIconProps {
  size?: number;
  className?: string;
}

const GradientHeartIcon: React.FC<GradientHeartIconProps> = ({ size = 18, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_iiii_4611_6570)">
        <path d="M8.9961 16.3125C9.10001 16.3125 9.21691 16.2813 9.3468 16.2188C9.48188 16.1563 9.60917 16.0859 9.72866 16.0078C11.1834 15.0703 12.4433 14.0859 13.5083 13.0547C14.5786 12.0234 15.4073 10.9609 15.9944 9.86719C16.5815 8.77344 16.875 7.67188 16.875 6.5625C16.875 5.84375 16.7581 5.1875 16.5243 4.59375C16.2957 3.99479 15.9788 3.47917 15.5735 3.04688C15.1683 2.61458 14.6955 2.28125 14.1552 2.04688C13.6149 1.80729 13.033 1.6875 12.4095 1.6875C11.6354 1.6875 10.96 1.88542 10.3833 2.28125C9.81179 2.67188 9.34939 3.1875 8.9961 3.82812C8.6532 3.19271 8.19341 2.67708 7.61671 2.28125C7.04002 1.88542 6.36461 1.6875 5.59049 1.6875C4.96703 1.6875 4.38514 1.80729 3.84482 2.04688C3.30969 2.28125 2.8369 2.61458 2.42646 3.04688C2.02121 3.47917 1.70169 3.99479 1.4679 4.59375C1.2393 5.1875 1.125 5.84375 1.125 6.5625C1.125 7.67188 1.41595 8.77344 1.99784 9.86719C2.58492 10.9609 3.41359 12.0234 4.48386 13.0547C5.55931 14.0859 6.82441 15.0703 8.27913 16.0078C8.39343 16.0859 8.51812 16.1563 8.6532 16.2188C8.78829 16.2813 8.90259 16.3125 8.9961 16.3125Z" fill="url(#paint0_linear_4611_6570)"/>
      </g>
      <defs>
        <filter id="filter0_iiii_4611_6570" x="-0.375" y="-0.3125" width="19.25" height="18.625" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-0.5" dy="-2"/>
          <feGaussianBlur stdDeviation="1.5"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4611_6570"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="-1.5" dy="5.5"/>
          <feGaussianBlur stdDeviation="1"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.341176 0 0 0 0 0.541176 0 0 0 0.9 0"/>
          <feBlend mode="normal" in2="effect1_innerShadow_4611_6570" result="effect2_innerShadow_4611_6570"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="2" dy="2"/>
          <feGaussianBlur stdDeviation="1.25"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"/>
          <feBlend mode="normal" in2="effect2_innerShadow_4611_6570" result="effect3_innerShadow_4611_6570"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dx="0.5" dy="0.5"/>
          <feGaussianBlur stdDeviation="3"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.418495 0 0 0 0 0.643702 0 0 0 1 0"/>
          <feBlend mode="normal" in2="effect3_innerShadow_4611_6570" result="effect4_innerShadow_4611_6570"/>
        </filter>
        <linearGradient id="paint0_linear_4611_6570" x1="1.125" y1="1.6875" x2="17.0032" y2="1.82807" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF45A9"/>
          <stop offset="1" stopColor="#FF6A6A"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientHeartIcon;